export interface Buyer {
  name: string
  location: string
}

export const buyers: Buyer[] = [
  { name: 'María F.', location: 'Bogotá, Colombia' },
  { name: 'Andrés G.', location: 'Ciudad de México, México' },
  { name: 'Lucía R.', location: 'Buenos Aires, Argentina' },
  { name: 'Camila S.', location: 'Santiago, Chile' },
  { name: 'Diego M.', location: 'Lima, Perú' },
  { name: 'Valentina P.', location: 'Madrid, España' },
  { name: 'Sebastián T.', location: 'Quito, Ecuador' },
  { name: 'Daniela V.', location: 'Guadalajara, México' },
  { name: 'Joaquín L.', location: 'Montevideo, Uruguay' },
  { name: 'Isabella C.', location: 'San José, Costa Rica' },
  { name: 'Mateo H.', location: 'Asunción, Paraguay' },
  { name: 'Fernanda O.', location: 'Medellín, Colombia' },
  { name: 'Ricardo A.', location: 'Panamá, Panamá' },
  { name: 'Gabriela N.', location: 'Santo Domingo, R. Dominicana' },
  { name: 'Tomás B.', location: 'Barcelona, España' },
]
